import type { LampMood } from "../djinn/lamp-state";

/** What the project rail's Djinn row is called for each state of the lamp; the word beside it says the same. */
export const djinnRailName = (mood: LampMood, count = 1, paused = false) =>
  mood === "waiting"
    ? `Djinn, ${String(count)} waiting on you`
    : mood === "found" || mood === "several"
      ? `Djinn, ${String(Math.max(1, count))} new`
      : mood === "working"
        ? "Djinn, working"
        : paused
          ? "Djinn, paused"
          : mood === "down"
            ? "Djinn, can’t think right now"
            : "Djinn";
